import { Eye, Compass, Sparkles, type LucideIcon } from "lucide-react"

export interface XiaozhiPoint {
  icon: LucideIcon
  title: string
  description: string
}

export const xiaozhiPoints: XiaozhiPoint[] = [
  {
    icon: Eye,
    title: "知道你在看什么",
    description:
      "在错题详情、训练报告、知识图谱里唤起小智，它带着上下文回答，不用你从头解释。",
  },
  {
    icon: Compass,
    title: "引导，而不是代答",
    description:
      "先帮你找到卡在哪一步，再一起看思路——答案是你自己想通的，才算真的学会。",
  },
  {
    // 小智品牌标识：AI 北极星（SPRINT_639）
    icon: Sparkles,
    title: "全流程都在",
    description:
      "录入、训练、复盘，任何页面都能问。答完还告诉你下一步可以做什么。",
  },
]

export interface ChatLine {
  role: "student" | "xiaozhi"
  text: string
}

export const xiaozhiContextTag = "来自：错题详情 · 数学"

export const xiaozhiChat: ChatLine[] = [
  { role: "student", text: "这道题我到底错在哪？" },
  {
    role: "xiaozhi",
    text: "我们一起看看——第二步移项时，+5 到了等号右边还是 +5。你觉得这里应该变成什么？",
  },
  { role: "student", text: "……应该变成 -5？" },
  {
    role: "xiaozhi",
    text: "对了，移项要变号。这一改，答案就出来了。要不要去练两道同类题巩固一下？",
  },
]
